<template>
  <div id="app">
    <header_menu></header_menu>
    <router-view/>
  </div>
</template>
<script>
import header_menu from "@/components/header_menu";
export default {
  components:{
    header_menu,
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
  min-width: 1330px;
}
</style>
